/* eslint-disable camelcase */
import { setServerLoading } from "../store/components/BuildTargets.slice";
import MainServices from "./Main.services";
import { fGetDashboardJSON, getCountryCode, getCountrySQSURL, isCountryMongoAvailable, isCountryXMLAvailable, userRequestQueue, userResponseQueue } from "../utils/oneintelligence/OneIntelligenceHelper";
import store from "../store/store";
import ConfigServices from "./Config.services";
import getState, { createPromise, dynamicSort, generateGUID } from "../utils/MainHelper";
import { message } from "antd";
import TrackFeatureServices from "./TrackFeature.services";

class OneIntelligenceServices {
    constructor() {
        this.savantCountryObj = {};
        this.countryAvailableList = null;
        this.listSubjectLimit = null;
        this.treeBucket = "sqreem-inihaw-keywords";
        this.treeInitialPath = "$country/TREND/GOOGLE/$market_package/$tree_type/";
        this.treeInitialPathForVariant = "TREND\\GOOGLE\\$country\\$market_package\\$tree_type";
        this.cachedUserTreePermission = {};
        this.cachedTreeConfig = {};
        this.savantRead = "https://sqs.ap-southeast-1.amazonaws.com/788016873502/savantread_20221115"
    }

    // getAvailableCountryList() {
    //     return this.countryAvailableList;
    // }

    getListSubjectLimit() {
        return this.listSubjectLimit;
    }

    async loadSavantUrls() {
        const { dispatch } = store;
        const savantKeys = process.env.REACT_APP_OI_SERVERS_KEY || "savantUrlKeys";
        const attributes = await ConfigServices.loadApplicationConfig()

        if (attributes.listSubjectLimit !== undefined) {
            this.listSubjectLimit = parseInt(attributes.listSubjectLimit, 10);
        }
        const prms = attributes[savantKeys].map((key, index) => {
            dispatch(setServerLoading({
                key,
                value: false
            }));
            return ConfigServices.getSavantKeyFile(key).then((obj) => {
                const { url, countries, sqsUrlMongo, availableInMongo, sqsUrlXML, urlXML, availableInXML } = obj
                const urlName = `savant-url-${index + 1}`;
                MainServices.urls(urlName, url);
                dispatch(setServerLoading({
                    key,
                    value: true
                }));
                countries.forEach((savantCode) => {
                    this.savantCountryObj[savantCode] = {
                        url,
                        urlKey: urlName,
                        code: savantCode,
                        server: key,
                        sqsUrlMongo,
                        sqsUrlXML,
                        urlXML,
                        mongoAvailable: (availableInMongo || []).includes(savantCode),
                        xmlAvailable: (availableInXML || []).includes(savantCode)
                    };
                })
                return
            })
        })
        return Promise.all(prms)
    }

    getSavantCountryObj(region) {
        return this.savantCountryObj[region];
    }

    async publishDashboard(filename = "Puiblished Dashboard", progress = () => { }) {
        const state = getState("buildTargets").setup;
        const {
            marketPackage: {
                name: subMarketPackage,
                parent: {
                    name: marketPackage
                }
            }
        } = state

        const omCode = getCountryCode("savant");
        const { username } = MainServices.userDetails()
        const account = MainServices.getAccount()
        const requestBody = {
            path: `oneintelligence/${account}~${username}/${marketPackage}/${subMarketPackage}/${omCode}/${filename}.json`
        };

        const reponse = await MainServices.getFile(requestBody.path, "dashboard");
        const { LastModified } = reponse || {};
        if (LastModified) {
            return Promise.resolve({ error: true });
        }
        const jsonToUpload = await fGetDashboardJSON(filename);

        const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: "actionsPublishDashboard" })
        const url = MainServices.url + "oneintel/publishdashboard"
        startMonitor(requestBody, { url })
        // return MainServices.uploadFile(requestBody.path, JSON.stringify(jsonToUpload), { progress }).then(() => MainServices.post(

        return MainServices.uploadFile(requestBody.path, JSON.stringify(jsonToUpload), {}, "dashboard").then(() => MainServices.post(
            url,
            requestBody,
        )).then(({ data }) => {
            endMonitor(data, { url })
            return {
                password: data.password,
                path: `${process.env.REACT_APP_OI_APP_VIEWER}${requestBody.path.replace("oneintelligence/", "").replace(".json", "")}`
            }
        });
    }

    async listSubjects(
        limit = 10,
        items = [],
        region = "onemarket",
        retry = 0,
        statusCallback = () => { },
        cancelCallback = () => { },
        callBackGetUrl = () => { }
    ) {
        let isCancel = false;
        const cancel = (newVal) => {
            if (!newVal) return isCancel;
            isCancel = true;
            cancelCallback()
            return isCancel;
        };

        const urlObj = this.getSavantCountryObj(region);
        const data = {
            op: "and",
            limit,
            items,
            region,
            type: "keyword",
        };
        const opt = {
            bucket: "savantbeterasponse", // Bucket for S3 Polling of SQS Response
            sqsUrlName: "savantsqs", // SQS URL in App Info
            forceurl: true
        };

        if (!urlObj?.url) {
            message.error("This country is not loaded.");
            return {
                thenpromise: Promise.resolve({
                    notLoaded: true
                }),
                cancel
            };
        }
        const { promise, resolve } = createPromise()
        const returnStatus = (resp) => {
            if (resp.status === "PROCESSING") {
                if (resp.message) {
                    statusCallback(`${resp.message}.. please wait.`);
                }
            }
        };

        const parameters = {
            "url": urlObj?.url,
            "method": "POST",
            "contentType": "application/json",
            "_class": "Savant",
            "_function": "Algo1",
            "_app": "OILeg",
            data
        }

        let url = this.savantRead;
        const sessionId = generateGUID();

        const mongoAvailable = isCountryMongoAvailable()
        const xmlAvailable = isCountryXMLAvailable()
        if (mongoAvailable || xmlAvailable) {
            const { username } = MainServices.userDetails();
            const account = MainServices.getAccount();

            let { endPoint } = await MainServices.createQueue(sessionId, "algo1");
            url = getCountrySQSURL(parameters._function);

            if (xmlAvailable) {
                // endPoint = userResponseQueue();
                url = userRequestQueue();
            }
            parameters._endpoint = endPoint
            parameters._account = account;
            parameters._username = username;
            parameters.url = "";
            parameters.data.subjectslimit = 500;
            parameters.data.limit = 500;
        }

        callBackGetUrl(parameters, url)
        MainServices.sqsSendMessage(url, JSON.stringify(parameters)).then((resp) => {
            const { MessageId } = resp

            const recursive = (retry = 0) => {
                if (retry >= 60) {
                    return resolve({
                        message: "Unable to get response. Maximum retries exceeded."
                    });
                }
                setTimeout(function () {
                    if (cancel()) return
                    if (mongoAvailable || xmlAvailable) {
                        MainServices.receiveMessageSQS(sessionId, "algo1").then(({ response }) => {
                            resolve({ response, dontget: true });
                        }).catch(function (e) {
                            recursive((retry += 1));
                        });
                    } else {
                        MainServices.getFile(MessageId, "savant")
                            .then(function (resp) {
                                if (
                                    resp?.status?.toLocaleLowerCase() === "done" ||
                                    resp?.value ||
                                    resp?.success?.toLocaleLowerCase() === "true"
                                ) {
                                    return resolve(resp);
                                } else {
                                    returnStatus(resp)
                                    recursive((retry += 1));
                                }
                            })
                            .catch(function (e) {
                                recursive((retry += 1));
                            });
                    }

                }, 5000);
            };
            recursive()
        })
        let thenres; let
            thenrej;
        const thenpromise = new Promise((resolve, reject) => {
            thenres = resolve;
            thenrej = reject;
        });
        thenres(
            promise
                .then(async (resp) => {
                    if (resp.isCancel) return null;
                    const handleResponse = async (urldata, prm, res, rej) => {
                        if ((urldata.message && urldata.message.includes("still loading please wait")) && urldata.status === "ERROR") {
                            return {
                                stillLoading: true
                            };
                        }
                        if ((urldata.message && urldata.message.includes("not loaded")) && urldata.status === "ERROR") {
                            return {
                                notLoaded: true
                            };
                        }
                        if ((urldata.message && urldata.message.includes("was not present in the")) && urldata.status === "ERROR") {
                            return {
                                notLoaded: true
                            };
                        }
                        if ((urldata.message
                            && urldata?.message?.toLocaleLowerCase().includes("no savant result"))
                            && urldata.status === "ERROR") {
                            return {
                                noresult: true
                            };
                        }
                        returnStatus(urldata);
                        if (
                            (urldata.message && (urldata.message === "In Progress" || urldata.status === "ERROR"))
                            || (!urldata.message && urldata.status === "PROCESSING")
                        ) {
                            setTimeout((e) => {
                                if (res) res(readdownloadurl(url, ++retry));
                            }, 5000);
                            return prm;
                        }
                        const returndata = urldata;
                        if (
                            returndata.status === "ERROR"
                            && returndata.message
                            === `The given key '${region}/keyword' was not present in the dictionary.`
                        ) {
                            const { thenpromise: tPromise } = await this.listSubjects(
                                limit,
                                items,
                                "onemarket",
                                ++retry,
                                statusCallback
                            );
                            if (res) res(tPromise);

                            return prm;
                        }
                        return returndata;
                    }
                    if (resp.dontget) {
                        let res; let
                            rej;
                        const prm = new Promise((resolve, reject) => {
                            res = resolve;
                            rej = reject;
                        });
                        return handleResponse(resp.response, prm, res, rej)
                    }
                    const readdownloadurl = function (url, retry = 0) {
                        let res; let
                            rej;
                        const prm = new Promise((resolve, reject) => {
                            res = resolve;
                            rej = reject;
                        });
                        if (isCancel) {
                            return prm;
                        }
                        if (retry >= 5) {
                            setTimeout(async (e) => {
                                const { thenpromise: tPromise } = await this.listSubjects(
                                    limit,
                                    items,
                                    region,
                                    ++retry,
                                    statusCallback
                                );
                                res(tPromise);
                            }, 5000);
                            return res;
                        }
                        let id = url.split("/").find((text) => text.includes("sqsresponse") && text.includes(".json"));
                        if (id) {
                            id = `${id.split(".json")[0]}.json`;
                        }
                        let params = {};

                        try {
                            params = url.split("?")[1].split("&").reduce((acc, str) => {
                                const [key, value] = str.split("=")
                                acc[key.trim()] = value.trim()
                                return acc
                            }, {})
                        } catch (error) {

                        }

                        const sendGet = () => {
                            const { promise, resolve } = createPromise()
                            var xhr = new XMLHttpRequest();
                            xhr.open("GET", url, true);
                            xhr.onreadystatechange = function () {
                                if (xhr.readyState === 4 && xhr.status === 200) {
                                    var responseData = JSON.parse(xhr.responseText);
                                    resolve(responseData);
                                } else if (xhr.readyState === 4 && xhr.status !== 200) {
                                    resolve({ status: xhr.status })
                                }
                            };
                            xhr.send();
                            return promise
                        }

                        return sendGet().then(async (urldata) => {
                            if (urldata[id]) urldata = urldata[id];
                            return handleResponse(urldata, prm, res, rej)
                        });
                    };
                    if (!resp || !resp.data) {
                        const { thenpromise: tPromise } = await this.listSubjects(
                            limit,
                            items,
                            region,
                            ++retry,
                            statusCallback
                        );
                        return tPromise;
                    } return readdownloadurl(resp.data.downloadUrl);
                })
                .catch((e) => {
                    if (e.status == 504 && retry < 2) {
                        let res; let
                            rej;
                        const prm = new Promise((resolve, reject) => {
                            res = resolve;
                            rej = reject;
                        });
                        setTimeout(async (e) => {
                            const { thenpromise: tPromise } = await this.listSubjects(
                                limit,
                                items,
                                region,
                                ++retry,
                                statusCallback
                            );
                            res(tPromise);
                        }, 5000);
                        return prm;
                    } return null;
                })
        );
        return { thenpromise, cancel };
    };


    filterSavantKeywords(keywordsObj, forWebsite, website) {
        const data = {};
        let resultkeywords = [];
        let lowscore = false;
        let resultid = website || null;
        const scorelimit = isCountryMongoAvailable() || isCountryXMLAvailable() ? 0 : 0.2;

        if (resultid) {
            data[resultid] = [];
        }

        resultkeywords = this.filterPerfectScoreKeywords(keywordsObj, forWebsite);
        resultkeywords.forEach((resultkeyword) => {
            if (keywordsObj[resultkeyword] <= scorelimit) {
                lowscore = true;
                return;
            }
            if (resultid === null) {
                resultid = resultkeyword;
                data[resultid] = [];
            }
            data[resultid].push({
                fs: "folder",
                image: null,
                name: `${resultkeyword}.keyword`,
                text: resultkeyword,
                value: `${resultkeyword}.keyword`
            });
        });
        if (data[resultid]?.length > 0) {
            data[resultid] = data[resultid].sort(dynamicSort("name"));
        }
        let error = "";
        if (lowscore) error = "Low audience reach. Please refine your query.";
        else if (resultkeywords.length === 0) error = "Savant: Query too specific. Please try again";

        if (data[resultid]) {
            return data;
        }
        return {
            isError: true,
            error
        };
    }

    filterPerfectScoreKeywords(data, forWebsite) {
        const perfectscore = 1;
        let ret = [];
        const keywords = Object.entries(data);
        const keywordswithperfectscore = keywords.filter(
            (value) => data[value] === perfectscore
        );

        const sortkeywords = keywords.sort((a, b) => a[1] + b[1]);

        const sortkeywordskey = Object.keys(Object.fromEntries(sortkeywords));

        if (keywordswithperfectscore.length <= 10) {
            if (forWebsite) {
                ret = keywords
                    .filter((kw) => {
                        const [name, score] = kw;
                        if (score >= 0.4) return kw;
                    })
                    .map((kw) => kw[0])
                    .slice(0, 10);
            } else ret = sortkeywordskey.slice(0, 10);
        } else if (keywordswithperfectscore.length > 20) {
            ret = keywordswithperfectscore.sort().slice(0, 20);
        } else if (keywordswithperfectscore.length > 10) {
            ret = keywordswithperfectscore;
        }

        return ret;
    };

    getPublishedDashboard(password, {
        creds,
        marketpackage,
        submarketpackage,
        omcountry,
        filename
    }, progress) {
        const [account, username] = creds.split("~")
        const requestBody = {
            path: `oneintelligence/${creds}/${marketpackage}/${submarketpackage}/${omcountry}/${filename}.json`,
            password,
            _account: account,
            _username: username
        };

        const url = MainServices.url + "oneintel/getpublishdashboard"
        return MainServices.post(
            url,
            requestBody,
        ).then(({ data: resp }) => {
            if (typeof resp === "string") {
                if (resp.includes("does not exists")) {
                    message.error("Invalid password. Please check your input and try again.");
                } else {
                    message.error(resp);
                }
            } else if (resp.isSuccess) {
                const sendGet = (presignedUrl) => {
                    const { promise, resolve } = createPromise()
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", presignedUrl, true);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4 && xhr.status === 200) {
                            var responseData = JSON.parse(xhr.responseText);
                            resolve(responseData);
                        } else if (xhr.readyState === 4 && xhr.status !== 200) {
                            resolve({ status: xhr.status })
                        }
                    };
                    xhr.send();
                    xhr.addEventListener('progress', function (e) {
                        if (progress) progress(e);
                    });
                    return promise
                }
                return sendGet(resp.presignedUrl);
            } else {
                message.error("Error in getting published dashboard.");
            }
        });
    }
}

export default new OneIntelligenceServices();
